import * as constants from 'frontend/routes/constants'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'
import { TASK_DEFINITION_ROUTE_NAME } from 'frontend/routes/constants'
import { TASK_MANAGER_ASSIGNMENT } from 'frontend/constants/callers'
import { TASK_MANAGER as TASK_MANAGER_SOURCE } from 'frontcore/constants/taskManager'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const TaskDetails = () => import('frontend/pages/tasksDefinition/TaskDetailsPage')
const TaskGroupsPage = () => import('frontend/pages/tasksDefinition/TaskGroupsPage')
const TaskManagerPage = () => import('frontend/pages/tasksDefinition/TaskManagerPage')
const TasksAssignment = () => import('frontend/pages/tasksDefinition/TasksAssignment')
const TasksList = () => import('frontend/pages/tasksDefinition/TasksListPage')

export default [{
    path: TASK_DEFINITION_ROUTE_NAME,
    name: TASK_DEFINITION_ROUTE_NAME,
    component: TaskManagerPage,
    redirect: { name: SETTINGS_CARDS_TOKENS.tpmTasksCreation.name },
    children: [
        {
        path: 'list',
        name: SETTINGS_CARDS_TOKENS.tpmTasksCreation.name,
        components: {
            header: HeaderFactoryStructure,
            filters: RemoteFilters,
            default: TasksList,
        },
        props: {
            header: { caller: TASK_MANAGER_ASSIGNMENT },
            default: { source: TASK_MANAGER_SOURCE },
        },
        },
        {
        path: 'list/:id',
        name: constants.TASK_DETAILS_ROUTE_NAME,
        component: TaskDetails,
        props: { source: TASK_MANAGER_SOURCE },
        },
        {
        path: 'new',
        name: constants.TASK_NEW_ROUTE_NAME,
        component: TaskDetails,
        props: { source: TASK_MANAGER_SOURCE },
        },
        {
        path: 'tasks-assignment',
        name: SETTINGS_CARDS_TOKENS.tpmTasksAssignment.name,
        components: {
            header: HeaderFactoryStructure,
            filters: RemoteFilters,
            default: TasksAssignment,
        },
        props: {
            header: { caller: TASK_MANAGER_ASSIGNMENT },
            default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
        },
        },
        {
        path: 'tasks-groups',
        name: SETTINGS_CARDS_TOKENS.tpmTasksGroups.name,
        components: {
            header: HeaderFactoryStructure,
            default: TaskGroupsPage,
        },
        props: {
            header: { caller: TASK_MANAGER_ASSIGNMENT, multiple: false },
            default: { source: TASK_MANAGER_SOURCE, caller: TASK_MANAGER_ASSIGNMENT },
        },
        },
    ],
}]
